import useBusinessPostApi from './useBusinessPostApi.js';
import { ONBOARDING_CACHE, setOnboardingQuery } from './Queries';
import { isMobile } from '~/lib/Utils';

export function useCompleteStep() {
    const { save, isSaving } = useBusinessPostApi(`/onboarding/complete`);

    return {
        complete: key => {
            const isAlreadyCompleted = ONBOARDING_CACHE.find(
                o => o.key === key && o.completed,
            );

            console.log('isAlreadyCompleted=', isAlreadyCompleted, key);
            if (!isAlreadyCompleted) {
                save({ key: key }).then(result => {
                    console.log('setting query=', result);
                    setOnboardingQuery(result, isMobile());
                });
            }
        },
        isCompleting: isSaving,
    };
}
